import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popover from 'react-popover'
import { Link } from 'react-router-dom'
import cn from 'classnames'

import NotificationsList from 'app/domains/routes/Notifications/NotificationsList'
import NotificationIcon from 'app/components/SVGS/NotificationIcon'

import './styles.scss'
const bc = 'notification-bar'

class NotificationBar extends Component {
  state = {
    showTooltip: false,
  }

  onButtonClick = () => {
    const { showTooltip } = this.state
    if (!showTooltip) {
      const { onLoadNotifications, markNotificationsRead, loaded, unreadCount } = this.props
      if (!loaded) {
        onLoadNotifications()
      }
      if (unreadCount) {
        markNotificationsRead()
      }
    }
    this.setState({ showTooltip: !showTooltip })
  }

  renderIcon = () => {
    const { unreadCount } = this.props
    return (
      <div className={`${bc}__icon-wrapper`}>
        {unreadCount ? <div className={`${bc}__count`}>{unreadCount}</div> : null}
        <div
          className={cn(`${bc}__icon`, {
            [`${bc}__icon--active`]: unreadCount,
          })}
        >
          <NotificationIcon />
        </div>
      </div>
    )
  }

  render() {
    const icon = this.renderIcon()
    return (
      <div className={bc}>
        {this.props.isMobileOnly ? (
          <Link to={'/notifications'} className={`${bc}__button`}>
            {icon}
          </Link>
        ) : (
          <Popover
            isOpen={this.state.showTooltip}
            preferPlace="below"
            place={null}
            tipSize={7}
            body={
              <div className={`${bc}__list`}>
                <NotificationsList />
              </div>
            }
            onOuterAction={() => this.setState({ showTooltip: false })}
          >
            <div className={`${bc}__button`} onClick={this.onButtonClick}>
              {icon}
            </div>
          </Popover>
        )}
      </div>
    )
  }
}

NotificationBar.propTypes = {
  unreadCount: PropTypes.number.isRequired,
  loaded: PropTypes.bool.isRequired,
  onLoadNotifications: PropTypes.func.isRequired,
  markNotificationsRead: PropTypes.func.isRequired,
  isMobileOnly: PropTypes.bool.isRequired,
}

export default NotificationBar
